<template>
  <v-autocomplete
    ref="signersAutocomplete"
    v-bind="$attrs"
    v-model="model"
    :items="items"
    :return-object="true"
    item-value="id"
    item-text="displayNameWithCompany"
    :messages="messages"
    clearable
    multiple
    small-chips
    deletable-chips
    hide-selected
    @keydown.enter.stop
    @change="$refs.signersAutocomplete.lazySearch=''"
  >
    <template v-slot:item="{ item }">
      <div class="d-flex p-w-100 justify-space-between">
        <span :class="{ 'font-weight-bold': item.isMember }">
          {{ item.displayNameWithCompany }}
        </span>

        <v-tooltip v-if="!item.email && !item.phone" bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small>mdi-alert-circle-outline</v-icon>
          </template>
          {{ $t('contract.edit.signerWithoutDetails') }}
        </v-tooltip>
      </div>
    </template>
  </v-autocomplete>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: undefined
    },
    items: {
      type: Array
    }
  },


  computed: {
    ...mapGetters('contact', ['shortContactById']),

    model: {
      get () {
        return this.value?.map(signer => this.shortContactById(signer.id) || signer) || []
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    messages () {
      if (this.model && this.model.filter(x => !x.email && !x.phone).length) {
        return this.$t('contract.edit.signersWithoutDetailsSelected')
      }

      return null
    }
  }
}
</script>
